import { createStyles, makeStyles } from '@material-ui/core';
import TrashIcon from '../../../assets/images/trash.svg';
import LegacyColors from '../../layout/theme/utils/colors';
import Colors from '../../layout/theme-next/colors';

export default makeStyles((theme) =>
  createStyles({
    root: {
      '& .MuiOutlinedInput-root': {
        minHeight: 50,
        background: Colors.white,
      },
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.grey[400],
      },
      '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.grey[500],
      },
    },
    inputRoot: {
      alignItems: 'center',
      paddingTop: theme.spacing(0.5),
      paddingBottom: theme.spacing(0.5),
    },
    // light blue, like the References chips
    tag: {
      maxWidth: '100%',
      margin: theme.spacing(0.25, 0.5, 0.25, 0),
      borderRadius: 2,
      background: LegacyColors.light_blue,
      '& .MuiChip-label': {
        minWidth: 0,
        padding: theme.spacing(0.25, 1, 0.25, 0.75),
      },
    },
    endAdornment: {
      '& .MuiIconButton-root': {
        color: theme.palette.grey[600],
      },
    },
    popper: {
      zIndex: theme.zIndex.modal + 1,
    },
    paper: {
      marginTop: theme.spacing(0.5),
      border: `1px solid ${theme.palette.grey[300]}`,
      boxShadow: theme.shadows[2],
    },
    listbox: {
      maxHeight: 280,
      padding: theme.spacing(0.5),
    },
    option: {
      ...theme.typography.body2,
      minHeight: 36,
      borderRadius: 4,
      '&[data-focus="true"]': {
        background: theme.palette.grey[200],
      },
      '&[aria-selected="true"]': {
        background: theme.palette.grey[300],
      },
    },
    deleteChip: {
      '& .MuiChip-root': {
      },
      // FBAutocomplete draws the default close icon; paint the red bin over it instead.
      // It shows only while the chip is hovered (or focused, for keyboard users).
      '& .MuiChip-root:not(.Mui-disabled) .MuiChip-deleteIcon': {
        width: 14,
        height: 16,
        margin: theme.spacing(0, 1, 0, 0.5),
        background: `url(${TrashIcon}) center / contain no-repeat`,
        '& path': {
          display: 'none',
        },
        opacity: 0,
        transition: theme.transitions.create('opacity', { duration: 200 }),
      },
      '& .MuiChip-root:not(.Mui-disabled):hover .MuiChip-deleteIcon, & .MuiChip-root:not(.Mui-disabled):focus .MuiChip-deleteIcon': {
        opacity: 1,
      },
      '& .MuiChip-root.Mui-disabled': {
        opacity: 1,
        color: theme.palette.text.primary,
        background: LegacyColors.light_blue,
      },
      '& .MuiChip-root.Mui-disabled .MuiChip-deleteIcon, & .MuiChip-root.Mui-disabled .MuiChip-deleteIconSmall': {
        display: 'none',
      },
    },
  }),
);
